module.exports = __webpack_public_path__ + "static/media/climber_icon_contact.9425a758.svg";